import socket from './socket';

/* Actions */

const createCardRelation = (cardId, data, headers) =>
  socket.post(`/cards/${cardId}/relations`, data, headers);

const deleteCardRelation = (id, headers) => {
  console.log('DELETE RELATION', id);

  return socket.delete(`/card-relations/${id}`, undefined, headers);
};

export default {
  createCardRelation,
  deleteCardRelation,
};
